import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/browser'
import configureStore from './react-app/store'
import './browser-app.less'
import App from './react-app/entries/b2b'
import * as serviceWorker from './serviceWorker'
import { getLoadSessionAction } from './react-app/store/session/action-creators'
import { LOAD_PAGE_DONE, LOAD_PAGE_FAILED } from './react-app/store/page/actions'
import ErrorBoundary from './react-app/utilits/error-boundary'
import { isSessionOptionalPath } from './react-app/utilits/public-registration-paths'

if (process?.env?.NODE_ENV === 'production') {
  Sentry.init({
    dsn: '',
  })
}

export const store = configureStore({
  page: {
    isLoading: true,
  },
  session: {
    sessionData: {},
  },
})

const pathname = window.location?.pathname || ''
const dataToLoad = isSessionOptionalPath(pathname) ? [] : [store.dispatch(getLoadSessionAction())]

Promise.all(dataToLoad)
  .then(data => {
    store.dispatch({ type: LOAD_PAGE_DONE, payload: data })
  })
  .catch(err => {
    store.dispatch({ type: LOAD_PAGE_FAILED, payload: err })
  })

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)
  const isDevelopment = process.env.NODE_ENV === 'development'
  const app = (
    <BrowserRouter>
      <ErrorBoundary>
        <App store={store} />
      </ErrorBoundary>
    </BrowserRouter>
  )
  root.render(isDevelopment ? app : <React.StrictMode>{app}</React.StrictMode>)
}

serviceWorker.unregister()
